import RestService from './RestService';
import Managers from './ManagersService';
import Settings from './SettingsService';
import Companies from './CompaniesService';
import Categories from './CategoriesService';
import ThreatAreas from './ThreatAreasService';
import Questions from './QuestionsService';
import Subjects from './SubjectsService';
import Subscriptions from './SubscriptionsService';
import ApiKeys from './ApiKeysService';

export default class Partners extends RestService {
    constructor(asSuper = false) {
        super('/partners');
    }

    companiesService(partnerId) {
        return new Companies(false, this, partnerId);
    }

    categoryService(partnerId) {
        return new Categories(this, partnerId);
    }

    threatAreasService(partnerId) {
        return new ThreatAreas(this, partnerId);
    }

    questionsService(partnerId) {
        return new Questions(this, partnerId);
    }

    subjectsService(partnerId) {
        return new Subjects(this, partnerId);
    }

    subscriptionsService(partnerId) {
        return new Subscriptions(this, partnerId);
    }

    managersService(partnerId) {
        return new Managers(this, partnerId);
    }

    settingsService(partnerId) {
        return new Settings(this, partnerId);
    }

    apiKeysService(partnerId) {
        return new ApiKeys(this, partnerId);
    }

    openManageSession(partnerId) {
        return this.post(`${this.baseUrl}/${partnerId}/create_portal_session`);
    }

    togglePartner(partnerId, enabled) {
        return this.post(`${this.baseUrl}/${partnerId}/toggle`, { enabled });
    }

    update(partnerId, data) {
        return this.put(`${this.baseUrl}/${partnerId}`, data);
    }

    getSettings(partnerId) {
        return this.get(`${this.baseUrl}/${partnerId}/settings`);
    }

    uploadLogo(partnerId, formData) {
        return this.put(`${this.baseUrl}/${partnerId}/logo`, formData);
    }

    removeLogo(partnerId) {
        return this.del(`${this.baseUrl}/${partnerId}/logo`);
    }

    uploadFavicon(partnerId, formData) {
        return this.put(`${this.baseUrl}/${partnerId}/favicon`, formData);
    }

    removeFavicon(partnerId) {
        return this.del(`${this.baseUrl}/${partnerId}/favicon`);
    }

    getTranslationOverrides(partnerId) {
        return this.get(
            `${this.baseUrl}/${partnerId}/translation-overrides`
        );
    }

    upsertTranslationOverrides(partnerId, payload) {
        const body =
            typeof payload === 'object' && payload && 'overrides' in payload
                ? payload
                : { overrides: payload };
        return this.put(
            `${this.baseUrl}/${partnerId}/translation-overrides`,
            body
        );
    }
}
